// assets/leoupdate.js
document.addEventListener('DOMContentLoaded', () => {
  console.log('⏱ Swatch guard: inizializzato – inizio polling');

  // 1) Prendo form, CTA e span di testo
  const form              = document.querySelector('form[data-product-form]');
  const addToCartBtn      = document.querySelector('[data-add-to-cart]');
  const addToCartTextSpan = addToCartBtn?.querySelector('[data-add-to-cart-text]');
  if (!form || !addToCartBtn || !addToCartTextSpan) {
    console.warn('❌ Form, CTA o testo non trovati – esco');
    return;
  }

  // 2) Memorizzo i testi
  const defaultText  = addToCartBtn.getAttribute('data-lang-available') 
                         || addToCartTextSpan.textContent.trim();
  const requiredText = addToCartBtn.getAttribute('data-lang-select-size') 
                         || 'Seleziona una taglia';

  // 3) Imposto subito aspetto disabilitato e testo guida
  addToCartBtn.classList.add('btn--disabled');
  addToCartTextSpan.textContent = requiredText;

  // 4) Polling ogni 200ms finché non compare la legenda “Taglia”
  const interval = setInterval(() => {
    const tagliaLegend = document.querySelector('.swatch--gl legend[data-name="Taglia"]');
    console.log('🔍 Polling… legend Taglia trovata:', !!tagliaLegend);
    if (!tagliaLegend) return;

    // Trovati gli swatch, stoppo il polling
    clearInterval(interval);
    console.log('✅ Swatch Taglia caricati: procedo');

    // 5) Calcolo indice e selectors dinamici
    const swatchGroup    = tagliaLegend.closest('.swatch--gl');
    const idx            = swatchGroup.getAttribute('data-option-index');
    const swatchSelector = `.swatch--gl[data-option-index="${idx}"] .name-option`;
    const inputSelector  = `input[name="globo-option-${idx}"]`;
    console.log('   idx=', idx, 'swatchSelector=', swatchSelector, 'inputSelector=', inputSelector);

    // 6) Creo l’overlay sopra la CTA
    const container = addToCartBtn.parentElement;
    if (getComputedStyle(container).position === 'static') {
      container.style.position = 'relative';
    }
    const overlay = document.createElement('div');
    Object.assign(overlay.style, {
      position:      'absolute',
      top:           0,
      left:          0,
      width:         '100%',
      height:        '100%',
      cursor:        'pointer',
      zIndex:        '9999',
      backgroundColor: 'transparent',
    });
    overlay.addEventListener('click', e => {
      console.log('🛑 Overlay click intercettato');
      e.preventDefault();
      e.stopPropagation();
      const target = document.querySelector(swatchSelector);
      console.log('   Scroll verso:', target);
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    container.appendChild(overlay);
    console.log('✅ Overlay aggiunto');

    // 7) Al change di un radio‑taglia, rimuovo overlay e ripristino CTA
    document.addEventListener('change', e => {
      if (e.target.matches(inputSelector)) {
        console.log('✅ Taglia selezionata:', e.target.value);
        addToCartBtn.classList.remove('btn--disabled');
        addToCartTextSpan.textContent = defaultText;
        overlay.remove();
        console.log('✅ Overlay rimosso, CTA abilitata');
      }
    });
  }, 200);
});
